import IDELayout from "./components/ide-layout";

function App() {
  return <IDELayout/>;
}

export default App;
